(function () {
  var hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');

  function setActive(images, index) {
    images.forEach(function (image, imageIndex) {
      image.classList.toggle('is-active', imageIndex === index);
    });
  }

  function initHoverMedia(root) {
    if (!hoverQuery.matches || !root || root.dataset.wasuiHoverMediaReady === 'true') return;

    var images = Array.prototype.slice.call(root.querySelectorAll('.wasui-hover-media__image'));
    if (images.length < 2) return;

    root.dataset.wasuiHoverMediaReady = 'true';

    root.addEventListener('pointerenter', function () {
      setActive(images, 1);
    });

    root.addEventListener('pointerleave', function () {
      setActive(images, 0);
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-wasui-hover-media]').forEach(initHoverMedia);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
